import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formActions from 'shared/actions/searchForm';
import cx from 'classnames';
import Paginate from 'desktop/components/Paginate/Paginate';
import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import TabButtons from 'desktop/components/TabButtons/TabButtons';
import DealerInfo from 'desktop/routes/dealer/components/DealerInfo/DealerInfo';
import NewsAndPromotions from 'desktop/routes/dealer/components/NewsAndPromotions/NewsAndPromotions';
import DealerImages from 'desktop/routes/dealer/components/DealerImages/DealerImages';
import PartList from 'desktop/routes/spareparts/components/PartList/PartList';
import { DEALER_TABS } from 'shared/constants/navigation';
import Link from 'shared/components/Link/Link';
import About from 'shared/components/About';
import FirmSpareSearchBar from '../components/FirmSpareSearchBar/SpareSearchBar';
import s from './Firm.css';
import { generateFirmsSearchUrl } from '../../../../shared/helpers/urls';

const PER_PAGE = 20;

class Firm extends React.Component {
  static propTypes = {
    queryParams: PropTypes.string.isRequired,
    firmInfo: PropTypes.shape().isRequired,
    firmsTypes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    shouldShowOffers: PropTypes.bool.isRequired,
    currentPage: PropTypes.number.isRequired,
    tab: PropTypes.string.isRequired,
    news: PropTypes.arrayOf(PropTypes.shape()),
    newsPage: PropTypes.number,
    newsPageCount: PropTypes.number,
    query: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
    // search
    formResults: PropTypes.shape().isRequired,
    transportType: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    news: null,
    newsPage: 0,
    newsPageCount: 0,
  };
  render() {
    const {
      currentPage,
      queryParams,
      firmInfo,
      tab,
      news,
      newsPage,
      newsPageCount,
      query,
      url,
      intl,
      shouldShowOffers,
      transportType,
      // search
      firmsTypes,
      formResults,
      formData,
      formVocabulary,
      selectedActions,
      formState,
    } = this.props;

    const {
      adverts_count: advertsCount = 0,
      photos,
      description,
      worktime,
      title,
      slug,
      tags,
      location,
      ...info
    } = firmInfo;

    const result = formResults[`spares-${queryParams}`];
    const parts = result && result.results;
    const pageCount = result ? Math.ceil(result.count / PER_PAGE) : 1;

    let tag = null;
    if (tags && tags.length === 1) {
      tag = tags[0];
    }

    const breadcrumbs = [
      {
        link: '/katalog-kompaniy',
        title: intl.formatMessage({ id: 'Каталог компаний' }),
      },
      {
        link: `/${generateFirmsSearchUrl({ tag })}`,
        title: tag && tag.name,
      },
      {
        link: `/${generateFirmsSearchUrl({ tag, location })}`,
        title: location && location.title,
      },
    ].filter(item => item.link && item.title);

    const tabButtons = [
      {
        title: intl.formatMessage({ id: 'О компании' }),
        tab: DEALER_TABS.ABOUT,
        slug: DEALER_TABS.ABOUT,
      },
      {
        title: intl.formatMessage({ id: 'Новости и Акции' }),
        tab: DEALER_TABS.BLOG,
        slug: DEALER_TABS.BLOG,
      },
    ];

    const offers = {
      title: intl.formatMessage({ id: 'Предложения' }),
      tab: DEALER_TABS.OFFERS,
      slug: null,
      badge: advertsCount,
    };

    if (shouldShowOffers) tabButtons.unshift(offers);
    const pathname = `/katalog-kompaniy/${slug}`;

    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <Breadcrumbs links={breadcrumbs} />
              <DealerInfo type={'firm'} schedule={worktime} title={title} {...info}>
                {photos.length > 0 && <DealerImages photos={photos} />}
              </DealerInfo>
              <TabButtons activeTab={tab} buttons={tabButtons} pathname={pathname} />
              {tab === DEALER_TABS.ABOUT && <About content={description} />}
              {tab === DEALER_TABS.BLOG &&
                <NewsAndPromotions
                  title={firmInfo.title}
                  query={query}
                  url={url}
                  news={news}
                  page={newsPage}
                  pageCount={newsPageCount}
                />}
              {tab === DEALER_TABS.OFFERS &&
                <div>
                  <div className={s.navWrapper}>
                    <ul className={s.list}>
                      {firmsTypes.map(type =>
                        <li
                          key={type.id}
                          className={cx(s.item, {
                            [s.active]: type.id === transportType.id,
                          })}
                        >
                          {type.id === transportType.id &&
                            <span className={s.link}>
                              {type.title}
                            </span>}
                          {type.id !== transportType.id &&
                            <Link to={`/${pathname}/?transport=${type.id}`} className={s.link}>
                              {type.title}
                            </Link>}
                        </li>,
                      )}
                    </ul>
                  </div>
                  <FirmSpareSearchBar
                    transportType={transportType}
                    formData={formData}
                    formState={formState}
                    pathname={`${pathname}/`}
                    formVocabulary={formVocabulary}
                    count={advertsCount}
                    selectedActions={selectedActions}
                    firmId={firmInfo.id}
                  />
                  <PartList parts={parts} selectedCurrency={formState.currency} title={title} />
                  {parts &&
                    parts.length > 0 &&
                    <Paginate
                      query={query}
                      url={url}
                      pageCount={pageCount > 100 ? 100 : pageCount}
                      initialPage={currentPage}
                    />}
                </div>}
            </div>
            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  formResults: searchForm && searchForm.results,
  formState: searchForm && searchForm.selected,
  formData: searchForm && searchForm.data,
  formVocabulary: searchForm && searchForm.vocabulary,
  locale: globals.locale,
  location: globals.location,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.sparesSetThunks,
      },
      dispatch,
    ),
    toggle: bindActionCreators(formActions.selectedActions.toggle, dispatch),
    clear: bindActionCreators(formActions.selectedActions.clear),
    clearForm: bindActionCreators(formActions.sparesSetThunks.clearSelected, dispatch),
  },
});

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Firm)));



// WEBPACK FOOTER //
// ./src/desktop/routes/firms/firm/Firm.js